import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import './styles.css';
import { url } from '../../constants/routes';
import { connect } from '../../reducers/index';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';

class ContactForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.changeName = this.changeName.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { name: '', email: '' };
  }

  changeName(event) {
    this.setState({ name: event.target.value });
  }

  changeEmail(event) {
    this.setState({ email: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.onChangeName(this.state.name);
    this.props.onChangeEmail(this.state.email);
    this.context.router.history.push(url.CERTIFICATE);
  }

  render() {
    const { role } = this.props;

    return (
      <div className="contact-form-page">
        <Navigation role={role} />
        <section>
          <div id="maincontent" className="container">
            <form className="contact-form" onSubmit={this.handleSubmit}>
              <Row className="text-center">
                <h3>Contact Form</h3>
                <Col xs={12} md={6}>
                  <label htmlFor="contact-form-name">
                    <h3>Name:</h3>
                  </label>
                  <input
                    type="text"
                    id="contact-form-name"
                    required={true}
                    value={this.state.name}
                    onChange={this.changeName}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <label htmlFor="contact-form-email">
                    <h3>E-mail:</h3>
                  </label>
                  <input
                    type="email"
                    id="contact-form-email"
                    required={true}
                    value={this.state.email}
                    onChange={this.changeEmail}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <input
                    type="submit"
                    className="btn btn-blue"
                    value="Submit"
                  />
                </Col>
              </Row>
            </form>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

ContactForm.propTypes = {
  role: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onChangeName: PropTypes.func.isRequired,
  onChangeEmail: PropTypes.func.isRequired
};

ContactForm.contextTypes = {
  router: PropTypes.object.isRequired
};

export default connect.contact(connect.role(ContactForm));



// WEBPACK FOOTER //
// ./src/containers/ContactForm/index.jsx